import { ItemAlergeno, ItemAlergenoMap } from 'app/modulos/recurso/item/item';

// O que a loja faz com o item que contem um alergeno do cliente. Vem do `agente/cliente`
// em `alergenosAcao`.
export enum ClienteAlergenoAcao {
  Nenhuma = 0,
  Alertar = 10,
  Remover = 20,
}

// Os codigos de `alergenosLista` sao os mesmos do `ItemAlergeno` (o `ClienteAlergeno` do
// backend e a mesma tabela), entao o perfil fala direto com o alergeno do item.
export type ClienteAlergenoPerfil = {
  lista: ItemAlergeno[];
  acao: ClienteAlergenoAcao;
};

// Como chega no `agente/cliente`. Cliente sem alergeno vem com `alergenos: false` e
// `alergenosLista`/`alergenosAcao` em NULL - nao `[]` e `0` como no exemplo do backend.
export type ClienteAlergenoOrigem = {
  alergenos?: boolean;
  alergenosLista?: number[] | null;
  alergenosAcao?: number | null;
};

const PERFIL_VAZIO: ClienteAlergenoPerfil = { lista: [], acao: ClienteAlergenoAcao.Nenhuma };

// `alergenos: false` desliga o perfil mesmo com lista preenchida: e o cliente dizendo que
// nao quer o recurso. Codigo desconhecido e descartado, para nao avisar de algo sem nome.
export function clienteAlergenoPerfil(origem: ClienteAlergenoOrigem): ClienteAlergenoPerfil {
  if (!origem?.alergenos) {
    return PERFIL_VAZIO;
  }
  const lista = (origem.alergenosLista || []).filter(
    (codigo, i, todos) => ItemAlergenoMap.has(codigo) && todos.indexOf(codigo) === i,
  ) as ItemAlergeno[];
  const acao = Object.values(ClienteAlergenoAcao).includes(origem.alergenosAcao as ClienteAlergenoAcao)
    ? (origem.alergenosAcao as ClienteAlergenoAcao)
    : ClienteAlergenoAcao.Nenhuma;
  if (!lista.length || acao === ClienteAlergenoAcao.Nenhuma) {
    return PERFIL_VAZIO;
  }
  return { lista, acao };
}

// Alergenos do item que estao no perfil do cliente, na ordem do item.
export function clienteAlergenoConflitos(alergenos: ItemAlergeno[], perfil: ClienteAlergenoPerfil): ItemAlergeno[] {
  const evitados = perfil?.lista || [];
  return (alergenos || []).filter(alergeno => evitados.includes(alergeno));
}

// "Leite" ou "Trigo, Leite e Ovos" para o aviso; vazio quando o item nao bate com o perfil.
export function clienteAlergenoAvisoTexto(alergenos: ItemAlergeno[], perfil: ClienteAlergenoPerfil): string {
  const nomes = clienteAlergenoConflitos(alergenos, perfil).map(alergeno => ItemAlergenoMap.get(alergeno));
  return nomes.length > 1 ? `${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}` : nomes[0] || '';
}
